!function(o){o.ngoValidators=o.ngoValidators||{},o.ngoValidators.notUppercase=function(o){return o&&o!==o.toUpperCase()}}(window);